import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import CardImage from "@/components/CardImage";
import FestivalCountdown from "@/components/FestivalCountdown";
import { ArrowRight } from "lucide-react";

// Uniform, admin-driven homepage festival promo card (image + copy + live countdown).
// Auto-hides once the festival has ended.
export default function FestivalPromo({ p, flip = false }) {
  const { pick, lang } = useLang();
  const endMs = p.end ? new Date(p.end).getTime() : 0;
  if (endMs && Date.now() > endMs) return null;
  const title = pick(p.title_hi, p.title_en) || p.title_en;
  const subtitle = pick(p.subtitle_hi, p.subtitle_en) || p.subtitle_en;
  const desc = pick(p.desc_hi, p.desc_en) || p.desc_en;
  return (
    <Link
      to={p.to || "#"}
      data-testid={`home-promo-${p.id}`}
      className={`group grid overflow-hidden rounded-xl border border-[var(--gold)]/40 bg-[var(--surface)] transition-all duration-500 hover:-translate-y-0.5 hover:border-[var(--gold)] hover:shadow-[0_16px_50px_rgba(199,80,0,0.12)] md:grid-cols-2`}
    >
      <div className={`relative min-h-[240px] overflow-hidden ${flip ? "md:order-2" : ""}`}>
        <CardImage src={p.image} alt={title} ratio="h-full min-h-[240px] md:min-h-[320px]" />
      </div>
      <div className={`relative flex flex-col justify-center bg-gradient-to-br from-[rgba(199,80,0,0.05)] via-[var(--parchment)] to-[rgba(184,134,11,0.07)] p-8 md:p-12 ${flip ? "md:order-1" : ""}`}>
        {subtitle && <p className="overline-label text-saffron">{subtitle}</p>}
        <h2 className={`mt-3 text-2xl leading-tight text-ink deva-lh md:text-3xl ${lang === "en" ? "font-serif-latin" : "font-deva"}`}>{title}</h2>
        {desc && <p className="mt-4 max-w-xl leading-relaxed text-ink-2">{desc}</p>}
        <span className="mt-6 inline-flex w-fit items-center gap-2 bg-[var(--saffron)] px-5 py-2.5 text-sm font-medium font-button text-white transition-colors group-hover:bg-[var(--saffron-dark)]">
          {pick("मार्गदर्शिका खोलें", "Open the guide")} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </span>
        {p.start && <FestivalCountdown startISO={p.start} endISO={p.end} testid={`${p.id}-countdown`} />}
      </div>
    </Link>
  );
}
